export default {
  RETRY: {
    START: 'START_RETRYING_PENDING_ACTIONS',
    END: 'END_RETRYING_PENDING_ACTIONS',
    ENABLE: 'ENABLE_RETRYING_PENDING_ACTIONS',
    DISABLE: 'DISABLE_RETRYING_PENDING_ACTIONS'
  }
}
